import React, { createContext, useContext, useReducer } from "react"

import {
  SEARCH_TERM_CHANGE,
  PRICE_RANGE_CHANGE,
  CHECKBOX_GROUP_CHANGE,
  FILTER_SITES,
  CLEAR_FILTERS,
} from "./actions"

let DEFAULT_STATE = {
  sitesFiltered: null,
  searchTerm: "",
  priceRange: { min: "", max: "" },
  siteDistricts: {},
  siteTypes: {},
  siteServices: {},
  sitePublicTransports: {},
  unitAttributes: {},
  unitTechnicalAttributes: {},
  siteParking: {},
  siteFundTypes: {},
  siteStatuses: {},
  siteArea: {},
  siteSustainability: {},
}

const SearchResultContext = createContext(DEFAULT_STATE)

const searchResultReducer = (state, { type, payload }) => {
  switch (type) {
    case SEARCH_TERM_CHANGE:
      return { ...state, searchTerm: payload }

    case PRICE_RANGE_CHANGE:
      return { ...state, priceRange: payload }

    case CHECKBOX_GROUP_CHANGE:
      return { ...state, [payload.groupName]: { ...payload.checkedState } }

    case FILTER_SITES:
      return { ...state, sitesFiltered: payload }

    case CLEAR_FILTERS:
      return { ...DEFAULT_STATE }

    default:
      throw new Error(`Unhandled action type: ${type}`)
  }
}

const SearchResultProvider = ({ children }) => {
  const [state, dispatch] = useReducer(searchResultReducer, DEFAULT_STATE)
  const value = { state, dispatch }

  return (
    <SearchResultContext.Provider value={value}>
      {children}
    </SearchResultContext.Provider>
  )
}

const useSearchResultContext = () => {
  const context = useContext(SearchResultContext)

  return context
}

export { SearchResultProvider, useSearchResultContext }
